import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { fetch, handleErrors } from '../../api';
import api from '../../api/endpoints';
import { filter } from 'lodash';

const prepareFilters = filters => {

  const obj = filter(filters, x => x.active).reduce((obj, item) => {
    switch (item.key) {
      case 'sort': {
        return ({ ...obj, sort: [item.value] });
      }
      case 'related_domains': {
        return ({ ...obj, related_domains: item.value.map(x => x.domain) });
      }
      case 'category_ids': {
        return ({ ...obj, category_ids: item.value.map(x => x.id) });
      }
      case 'link_category_ids': {
        return ({ ...obj, link_category_ids: item.value.map(x => x.id) });
      }
      default: {
        return ({ ...obj, [item.key]: item.value });
      }
    }
  }, {});

  return obj;
};

const prepareDataTable = data => {
  const dataTable = [];
  const mappedData = data.map(element => {
    return { ...element, selected: false };
  });

  mappedData.forEach(item => {
    const el = {
      key: item.user.uuid,
      uuid: item.user.uuid,
      user: item.user,
      status: item.status,
      rank: item.rank,
      tags: item.tags,
      stats: {
        clicks_per_link_group: item.stats ? item.stats.clicks_per_link_group : null,
        gmv_per_click_group: item.stats ? item.stats.gmv_per_click_group : null,
        gmv_per_period_group: item.stats ? item.stats.gmv_per_period_group : null,
        links_per_period_group: item.stats ? item.stats.links_per_period_group : null
      },
      recently_shared: item.recently_shared,
      top_brands: item.top_brands,
      operations: item
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getDiscover({ payload: { signal, searchQ, filters, curr_page } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.discover.get,
      data: {
        ...prepareFilters(filters),
        page: curr_page,
        q: searchQ
      },
      signal
    });

    const preparedData = {
      next: data.next,
      previous: data.previous,
      count: data.count,
      message: data.message,
      dataTable: prepareDataTable(data.results)
    };

    yield put(actions.getDiscoverDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getDiscoverFailed,
      endpoint: api.discover.get.url
    });
  }
}

function* getDiscoverTags({ payload: { signal, searchQ, curr_page } }) {
  try {
    const { data } = yield call(fetch, { api: api.discover.tags, params: { page: curr_page, q: searchQ }, signal });
    yield put(actions.getDiscoverTagsDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getDiscoverTagsFailed,
      endpoint: api.discover.tags.url
    });
  }
}

function* addDiscoverUsersTagsBulk({ payload: { uuids, tags, onSuccess, signal, handledErrors } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.discover.tagsBulk,
      data: {
        user_uuids: uuids,
        tags
      },
      signal
    });

    onSuccess && onSuccess();
    yield put(actions.addDiscoverUsersTagsBulkDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.addDiscoverUsersTagsBulkFailed,
      handledErrors,
      endpoint: api.discover.tagsBulk.url
    });
  }
}

export const addDiscoverUsersTagsBulkSaga = takeEvery(types.ADD_DISCOVER_USERS_TAGS_BULK_REQUEST, addDiscoverUsersTagsBulk);
export const getDiscoverSaga = takeEvery(types.GET_DISCOVER_REQUEST, getDiscover);
export const getDiscoverTagsSaga = takeEvery(types.GET_DISCOVER_TAGS_REQUEST, getDiscoverTags);


